import React from "react";

const TableSkeleton = ({ rows, cols }) => {
  const skeletonRows = Array.from({ length: rows }).map((_, index) => (
    <tr key={index}>
      {Array.from({ length: cols }).map((_, index) => (
        <td key={index} className="skeleton-cell"></td>
      ))}
    </tr>
  ));

  return (
    skeletonRows
  );
  
};

export default TableSkeleton;
